import axios from 'axios';

// Normalize backend URL to avoid trailing slashes
const RAW_URL = process.env.REACT_APP_BACKEND_URL || '';
const API_URL = RAW_URL.replace(/\/+$/, '');

const api = axios.create({
  baseURL: `${API_URL}/api`
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
